module.exports = __webpack_public_path__ + "a0cc832a2bddb05efb1d63fd785e4544.png";